import { useViewSistema } from '../../../hooks/useView'
import { FormProvider } from '../../../hooks/useForm'
import { lazy, Suspense } from 'react'
import { LoaderSuspense } from '../loader/LoaderSuspense'
import '../util/Custom.css'

const listaViews = {
    equipamentos: lazy(() => import('../../../modulos/projetos/FormEquipamento').then(module => { return { default: module.FormEquipamento } })),
    home: lazy(() => import('../../../main/Home').then(module => { return { default: module.Home } })),
    meus_dados: lazy(() => import('../../../modulos/cadastro/meus_dados/FormMeusDados').then(module => { return { default: module.FormMeusDados } })),
    projetos: lazy(() => import('../../../modulos/projetos/FormProjeto').then(module => { return { default: module.FormProjeto } })),
    tipo_equipamento: lazy(() => import('../../../modulos/projetos/FormTipoEquipamento').then(module => { return { default: module.FormTipoEquipamento } })),
}

const listaViewsGenericas = {
    /*tipos_anexo: {
        nomeForm: 'Tipo de Anexo', 
        artigo: 'o',
    }*/
}

function renderViews(views = []) {
    
    return views.map((f) => {
        const chave = f.chave.split('|')[0]

        const parametrosFormGenerico = listaViewsGenericas[chave]
        const CurrentView = (!parametrosFormGenerico ? listaViews[chave] : lazy(() => import('../../../modulos/form_generico/FormGenerico').then(module => { return { default: module.FormGenerico } })))

        return (
            <div
                key={f.chave}
                className={`tab-pane fade${(f.ativo ? " active show" : "")}`}
                id={`tab-${f.chave}`}
                aria-labelledby={`tab-menu-${f.chave}`}>
                    <FormProvider idForm={f.chave} tituloForm={f.titulo}>
                        {((CurrentView ?? parametrosFormGenerico) ? <CurrentView key={f.chave} {...f.parametros} {...parametrosFormGenerico} permissoes={f.permissoes} /> : <></>)}
                    </FormProvider>
            </div>
        )
    })
}

export function ViewGerencia(){
    const { views } = useViewSistema()
    return (
        <div className="content-wrapper">
            <div className="card-body pt-0 pl-0">
                <div className="tab-content" id="menu-tabContent">
                    <Suspense fallback={<LoaderSuspense />}>
                        {renderViews(views)}
                    </Suspense>
                </div>
            </div>
        </div>
    )
}